import { render, staticRenderFns } from "./auth-form-upload.vue?vue&type=template&id=6f1cc20c&scoped=true"
import script from "./auth-form-upload.vue?vue&type=script&lang=js"
export * from "./auth-form-upload.vue?vue&type=script&lang=js"
import style0 from "./auth-form-upload.vue?vue&type=style&index=0&id=6f1cc20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1cc20c",
  null
  
)

export default component.exports